import * as React from "react";
import {ModelControler} from "../../../service/modelController";
import {DetailToggle, details} from "../DetailButton/DetailToggle";

export let feature =[
    {
        name:"Grilldeckel",
        featureName:"Grilldeckel",
    },
    {
        name:"Unterschrank",
        featureName:"Unterschrank",
    },
    {
        name:"Gasflaschenhalter",
        featureName:"Gasflaschenhalter",
    },
    {
        name:"Drehspieß",
        featureName:"Drehspieß",
    },
    {
        name:"Seitenablage",
        featureName:"Tischbrenner-Seitenablage"
    },
    {
        name:"Tischbrenner",
        featureName:"Tischbrenner-Seitenablage"
    }
]

interface ToggleProps {
    name:string;
    featureName:string;
    modelID:string;
    productID:string;
    onClick:any;
    renderVisibility:any
}

interface ToggleState{
}
export class FeatureToggle extends React.Component<ToggleProps, ToggleState>{
    constructor(props:ToggleProps){
        super(props);
        this.state = {
        }
    }

    //HACKY -FL
    toggleFeature(){
        ModelControler.instance.toggleFeature(this.props.featureName, this.props.name);
        this.props.renderVisibility();
    }

    render(){
        return(
            <div className="buttons-bottom fade" onClick={() => {
                this.props.onClick();
                this.toggleFeature();
            }}>
                <p> {this.props.name} </p>
            </div>
        )
    }
}